/**
 * Context for Tabbable Mode Consumer and Provider
 */

import { createContext } from 'preact';

/**
 * Context props for Tabbable Mode
 */
type TabbableModeContextProps = {
  /**
   * State of Tabbable mode
   * @default true
   */
  isTabbable: boolean;

  /**
   * State of roving tab index mode
   * @default undefined
   */
  isRoving?: true;

  /**
   * id of currently focused element
   * @default undefined
   */
  focusedId?: string;
};

const initialContext: TabbableModeContextProps = {
  isTabbable: true
};

const TabbableModeContext = createContext<TabbableModeContextProps>(initialContext);

export { TabbableModeContext };
